/**
 * Daily Itinerary Tabs
 */

(function() {
    'use strict';

    function initDailyItinerary() {
        const containers = document.querySelectorAll('.daily-itinerary-tabs');

        containers.forEach(container => {
            const buttons = container.querySelectorAll('.itinerary-btn');
            const items = container.querySelectorAll('.itinerary-item');

            buttons.forEach(button => {
                button.addEventListener('click', function() {
                    const day = this.getAttribute('data-day');

                    // Remove active class
                    buttons.forEach(btn => btn.classList.remove('active'));
                    items.forEach(item => item.classList.remove('active'));

                    // Add active class
                    this.classList.add('active');
                    container.querySelector(`.itinerary-item[data-day="${day}"]`).classList.add('active');
                });
            });

            // Keyboard navigation
            container.querySelector('.itinerary-nav')?.addEventListener('keydown', function(e) {
                if (!document.activeElement.classList.contains('itinerary-btn')) return;

                const buttonsArray = Array.from(buttons);
                const currentIndex = buttonsArray.indexOf(document.activeElement);
                let nextIndex;

                if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
                    e.preventDefault();
                    nextIndex = currentIndex > 0 ? currentIndex - 1 : buttonsArray.length - 1;
                } else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
                    e.preventDefault();
                    nextIndex = currentIndex < buttonsArray.length - 1 ? currentIndex + 1 : 0;
                }

                if (nextIndex !== undefined) {
                    buttonsArray[nextIndex].focus();
                    buttonsArray[nextIndex].click();
                }
            });

            // Swipe on mobile
            if ('ontouchstart' in window) {
                let touchStartX = 0;

                items.forEach(item => {
                    item.addEventListener('touchstart', e => touchStartX = e.changedTouches[0].screenX, { passive: true });
                    item.addEventListener('touchend', function(e) {
                        const diff = touchStartX - e.changedTouches[0].screenX;
                        if (Math.abs(diff) < 50) return;

                        const activeBtn = container.querySelector('.itinerary-btn.active');
                        const buttonsArray = Array.from(buttons);
                        const currentIndex = buttonsArray.indexOf(activeBtn);

                        if (diff > 0 && currentIndex < buttonsArray.length - 1) {
                            buttonsArray[currentIndex + 1].click();
                        } else if (diff < 0 && currentIndex > 0) {
                            buttonsArray[currentIndex - 1].click();
                        }
                    }, { passive: true });
                });
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initDailyItinerary);
    } else {
        initDailyItinerary();
    }

})();
